import { render, staticRenderFns } from "./ksgl 111.vue?vue&type=template&id=2e3b0519&scoped=true"
import script from "./ksgl 111.vue?vue&type=script&lang=js"
export * from "./ksgl 111.vue?vue&type=script&lang=js"
import style0 from "../../views/matrix-page/assets/css/rem.css?vue&type=style&index=0&id=2e3b0519&prod&scoped=true&lang=css&external"
import style1 from "./ksgl 111.vue?vue&type=style&index=1&id=2e3b0519&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3b0519",
  null
  
)

export default component.exports